<template>
  <div>
    <v-main>
      <v-container fluid>
        <!-- <app-headline :title="title + ' ของ ' + this.$username" /> -->
        <v-row>
          <v-col>
            <v-card
              class="pt-3 pb-6"
              :class="$vuetify.breakpoint.smAndUp ? 'px-8' : 'px-5'"
            >
              <v-container class="py-0">
                <v-row align="center">
                  <span>ภาษา :</span>
                  <v-checkbox
                    class="ma-1 pa-0"
                    v-model="searchParams.th"
                    label="ภาษาไทย"
                    hide-details
                  ></v-checkbox>
                  <v-checkbox
                    class="ma-1 pa-0"
                    v-model="searchParams.en"
                    label="ภาษาอังกฤษ"
                    hide-details
                  ></v-checkbox>
                </v-row>
                <v-row align="center">
                  <span>สถานะ :</span>
                  <v-checkbox
                    class="ma-1 pa-0"
                    v-model="searchParams.isWait"
                    label="รอการตรวจสอบ"
                    hide-details
                  ></v-checkbox>
                  <v-checkbox
                    class="ma-1 pa-0"
                    v-model="searchParams.isProcess"
                    label="อยู่ระหว่างดำเนินการ"
                    hide-details
                  ></v-checkbox>
                  <v-checkbox
                    class="ma-1 pa-0"
                    v-model="searchParams.isDone"
                    label="จัดทำเรียบร้อยแล้ว"
                    hide-details
                  ></v-checkbox>
                </v-row>
                <v-row>
                  <v-btn color="primary" class="my-2" @click="initialInfo()">
                    ค้นหา
                  </v-btn>
                </v-row>
                <v-divider class="mt-3 mb-6"></v-divider>
                <v-row v-if="dataRecord.length <= 0">
                  <v-col class="text-center grey--text">
                    <h1 class="py-4">ไม่พบข้อมูล</h1>
                  </v-col>
                </v-row>
                <v-row
                  v-else
                  v-for="(data, index) in dataRecord"
                  :key="'datalist-' + index"
                >
                  <v-col class="pt-0 pb-1">
                    <cert-list :data="data" type="user" />
                  </v-col>
                </v-row>
              </v-container>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </div>
</template>

<script>
import CertList from '@/components/reqcer/CertList.vue'
export default {
  components: {
    CertList
  },
  data() {
    return {
      searchParams: {
        th: false,
        en: false,
        isWait: false,
        isProcess: false,
        isDone: false
      },
      title: 'สถานะคำขอรับรอง',
      reason: 1,
      count: 1,
      dataRecord: []
    }
  },
  computed: {
    // dataRecord() {
    //   return [
    //     {
    //       cardcode: '1',
    //       createDate: '19/07/2020',
    //       reason: 'ติดต่อสถาบันการเงิน',
    //       reasonID: 1,
    //       lang: 'tha',
    //       numberValue: 4,
    //       status: 'อยู่ระหว่างการดำเนินการ',
    //       statusID: 2
    //     },
    //     {
    //       cardcode: '2',
    //       createDate: '20/07/2020',
    //       reason: 'ขอวีซ่าเดินทาง',
    //       reasonID: 2,
    //       lang: 'eng',
    //       numberValue: 3,
    //       status: 'รอการตรวจสอบ',
    //       statusID: 1,
    //       country: 'เยอรมัน',
    //       startDate: '13/08/2020',
    //       endDate: '16/08/2020'
    //     },
    //     {
    //       cardcode: '3',
    //       createDate: '21/07/2020',
    //       reason: 'อื่นๆ',
    //       reasonID: 3,
    //       lang: 'tha',
    //       numberValue: 2,
    //       status: 'จัดทำเรียบร้อยแล้ว',
    //       statusID: 3
    //     }
    //   ]
    // }
  },

  async mounted() {
    const query = this.$route.query
    this.searchParams.th = query.th === 'true' ? true : false
    this.searchParams.en = query.en === 'true' ? true : false
    this.searchParams.isWait = query.isWait === 'true' ? true : false
    this.searchParams.isProcess = query.isProcess === 'true' ? true : false
    this.searchParams.isDone = query.isDone === 'true' ? true : false

    await this.initialInfo()
  },
  methods: {
    setQuery() {
      this.$router.push({ query: this.searchParams }).catch(() => {
        console.log('same page, same result')
      })
    },
    async initialInfo() {
      this.setQuery()
      const res = await this.apiGetInfo()
      this.dataRecord = res
      // console.log(this.dataRecord)
    },

    async apiGetInfo() {
      try {
        const res = await this.$store.dispatch(
          'reqCer/getUserList',
          this.searchParams
        )
        // console.log(res)
        return res.data.data
      } catch (e) {
        console.log(e.response || e)
      }
    }
  }
}
</script>
